__turbopack_context__.v({
  "activeProviderImg": "styles-module-scss-module__r_0QLa__activeProviderImg",
  "container": "styles-module-scss-module__r_0QLa__container",
  "img": "styles-module-scss-module__r_0QLa__img",
  "isActive": "styles-module-scss-module__r_0QLa__isActive",
  "isDarkMode": "styles-module-scss-module__r_0QLa__isDarkMode",
  "isProviders": "styles-module-scss-module__r_0QLa__isProviders",
  "listItem": "styles-module-scss-module__r_0QLa__listItem",
  "root": "styles-module-scss-module__r_0QLa__root",
  "rootList": "styles-module-scss-module__r_0QLa__rootList",
});
